<template>
  <div class="navLeft" @contextmenu.prevent>
    <div class="navleft-item">
      <div
        class="item"
        v-for="item in filteredNavList"
        :key="item.id"
        :class="item.pathArr.indexOf($route.name) >= 0 ? 'act' : ''"
        @click="itemClick(item)"
      >
        <svg-btn :icon-class="'icon-menu' + item.id" />
        {{ $t(item.pathName)}}
        <el-badge v-if="item.path == '/news'" class="item12" :value="$store.state.userMsgNub" :hidden="$store.state.userMsgNub == 0" :max="99"></el-badge>
        <el-badge v-if="item.path == '/myCollection' || item.path == '/collectionSet' || item.path == '/collectionShort'" class="item12" :value="$store.state.collectNum" :hidden="$store.state.collectNum == 0" :max="99"></el-badge>
        <div v-if="item.id == 12" class="betaBox">Beta</div>
        <svg-btn v-if="item.id == 2" icon-class='icon_todyh' style="margin-left:auto;margin-right:14px" />
      </div>
    </div>
    
    <!-- <div class="bugbox" @click="goFeedback">
      <svg-btn icon-class="icon-edit-bug" />
      <span>新版本 bug 反馈</span>
    </div> -->
    <!-- <div class="exPandBox" @click="oepnExPand" v-if="$store.state.userInfo.switchs?.referral_program_show_banner == 1">
      <img class="img" :src="$utils.getPng('ReferralProgram8')" />
    </div> -->
    <div class="useo-box" @click="$router.push({ path: '/vip' })">
      <div class="info-box">
        <img class="avater" :src="displayUserInfo.logo" alt="" />
        <div class="info-text">
          <div class="name">{{ displayUserInfo.nickname }}</div>
          <img class="new_tag_url" :src="displayVipInfo?.header?.new_tag_url" alt="">
        </div>
      </div>
      <div class="Memberdata">
        <div class="data-item">
          <div class="item-title"
           :style="{
                    fontSize: !isNaN(
                      displayVipInfo?.consume?.day_down_count
                    )
                      ? '14px'
                      : '12px',
                  }">
            {{ displayVipInfo?.consume?.day_down_count }}
          </div>
          <div class="item-text">{{ $t("userinfo.DownloadLimit") }}</div>
        </div>
        <div class="data-item data-item2">
          <div class="item-title">{{ displayVipInfo?.consume?.point }}</div>
          <div class="item-text">{{ $t("userinfo.awelfarepoint") }}</div>
        </div>
        <div class="data-item">
          <div class="item-title2">
            {{ displayVipInfo?.consume?.down_speed_text }}
          </div>
          <div class="item-text">{{ $t("userinfo.Downloadspeed") }}</div>
        </div>
      </div>
      <div class="space-box1">
        <el-progress
          :percentage="displayUsedPre > 100 ? 100 : displayUsedPre"
          :stroke-width="4"
          :text-inside="true"
        ></el-progress>
        <div class="Space-aa">
           <div class="Space-size">
             {{ displayVipInfo?.cloud_size?.self_size }}G /
             <span
               style="margin-left: 2px"
               :class="{
                 endless: displayVipInfo?.cloud_size?.cloud_size == '999999',
               }"
             >
               {{
                  displayVipInfo?.cloud_size?.cloud_size == "999999"
                   ? "∞"
                   : displayVipInfo?.cloud_size?.cloud_size + "G"
               }}</span
             >
           </div>
           <el-tooltip v-if="displayVipInfo?.cloud_size?.is_rate_flow == 1" placement="top">
              <template #content>
                <div class="tooltip-Spacelevel">
                  <div class="tooltip-item" v-for="(item,index) in displayVipInfo?.cloud_size?.cloud_size_text" :key="index">{{item}}</div>
                </div>
              </template>
              <svg-btn class="Spacelevel" icon-class="icon-Spacelevel"></svg-btn>
            </el-tooltip>
        </div>
      </div>

    </div>
    <div class="themesetBox">
      <div class="themeBox">
        <div
          v-for="item in themeList"
          class="one"
          :class="{ one2: $store.state.themeBtn == item }"
          @click="changeTheme(item)"
          :key="item"
        >
          <svg-btn :icon-class="'icon-switch-' + item" />
        </div>
      </div>
      <div class="setbox" @click="$router.push({ path: '/account' })">
        <svg-btn class="time1" icon-class="icon-account"></svg-btn>
      </div>
    </div>
    <!-- 悬浮短链组件 -->
    <ShortTooltip :top="214" :left="189"></ShortTooltip>
    <!-- 悬浮AI组件 -->
    <!-- <CustomTooltip :top="323" :left="48"></CustomTooltip> -->
    <BindPhone
      :isShow="isShowBindPhone"
      :type="bindType"
      :time="time"
      @getPhoneCode="getPhoneCode"
      @bindPhone="bindPhone"
      @confirmNameAuth="realNameAuth"
      @handleClose="isShowBindPhone = false"
    ></BindPhone>
  </div>
</template>

<script>
import {
  getCollectInfo,
} from "@/utils/apiList/home";
import {
  bindPhoneAPI,
  bindPhoneSendCode,
  realNameAuth,
} from '@/utils/apiList/account'
import BindPhone from '@/components/Cloud/BindPhone'
import CustomTooltip from "@/components/CustomTooltip";
import ShortTooltip from "@/components/ShortTooltip";
export default {
  components: {
    CustomTooltip,
    BindPhone,
    ShortTooltip,
  },
  data() {
    return {
      navList: [
        { id: 0, pathName: "common.vip", path: "/vip", pathArr: ["vip","welfare","activities"] },
        { id: 11, pathName: "common.homopa", path: "/homeCollection", pathArr: ["homeCollection"] },
        {
          id: 1,
          pathName: "common.Files",
          path:'/files',
          pathArr: ["files", "account","share","recycle","history","help","askdetail",'s','fmDown','tNewdown','g'],
        },
        {
          id: 12,
          pathName: "shortChain.shortLink",
          path: "/shortChain",
          pathArr: ["shortChain"],
        },
        {
          id: 10,
          pathName: "common.Set",
          path: "/set",
          pathArr: ["set","setRecycle"],
        },
        {
          id: 3,
          pathName: "common.Collect",
          path: "/myCollection",
          pathArr: ["myCollection","collectionSet","collectionShort"],
        },
        // { id: 4, pathName: "消息", path: "/news", pathArr: ["news"] },
        // { id: 9, pathName: "DeepSeek", path: "/ai", pathArr: ["ai"] },
        { id: 5, pathName: "common.app", path: "/app", pathArr: ["app"] },
        // {
        //   id: 2,
        //   pathName: "订阅号",
        //   path: "/",
        //   pathArr: [],
        // },
      ],
      routeAct: 0,
      themeList: ["system", "light", "dark"],
      bindType: 1,
      isShowBindPhone: false,
      time: 60,
      msgid: '',
      timerA: null,
      phone_item: {
        phone: '',
        pcode: '',
        sms_type: 0,
      },
      // 本地缓存的用户数据，用于避免退出登录时数据过快清除
      cachedUserInfo: {},
      cachedVipInfo: {},
      cachedUsedPre: 0,
    };
  },
  computed: {
    filteredNavList() {
      const isLoggedIn = this.$utils.getCookie(this.$glb.fmCookieName) != null;
      const shortUrlEnabled = this.$store.state.short_url_switch == 1;
      
      return this.navList.filter(item => {
        if (item.path == '/shortChain') {
          return isLoggedIn && shortUrlEnabled;
        }
        return true;
      });
    },
    // 优先使用本地缓存数据，避免退出登录时数据过快清除
    displayUserInfo() {
      return Object.keys(this.$store.state.userInfo).length > 0 
        ? this.$store.state.userInfo 
        : this.cachedUserInfo;
    },
    displayVipInfo() {
      return Object.keys(this.$store.state.VipInfo).length > 0 
        ? this.$store.state.VipInfo 
        : this.cachedVipInfo;
    },
    displayUsedPre() {
      return this.$store.state.usedPre || this.cachedUsedPre;
    },
  },
  created() {
    // 从localStorage恢复缓存数据
    this.loadCachedData();
  },
  methods: {
    // 从localStorage加载缓存数据
    loadCachedData() {
      try {
        const cachedUserInfo = localStorage.getItem('cachedUserInfo');
        const cachedVipInfo = localStorage.getItem('cachedVipInfo');
        const cachedUsedPre = localStorage.getItem('cachedUsedPre');
        
        if (cachedUserInfo) {
          this.cachedUserInfo = JSON.parse(cachedUserInfo);
        }
        if (cachedVipInfo) {
          this.cachedVipInfo = JSON.parse(cachedVipInfo);
        }
        if (cachedUsedPre) {
          this.cachedUsedPre = JSON.parse(cachedUsedPre);
        }
      } catch (error) {
        // console.warn('加载缓存数据失败:', error);
      }
    },
    
    // 保存数据到localStorage缓存
    saveCachedData() {
      try {
        if (Object.keys(this.$store.state.userInfo).length > 0) {
          this.cachedUserInfo = { ...this.$store.state.userInfo };
          localStorage.setItem('cachedUserInfo', JSON.stringify(this.cachedUserInfo));
        }
        if (Object.keys(this.$store.state.VipInfo).length > 0) {
          this.cachedVipInfo = { ...this.$store.state.VipInfo };
          localStorage.setItem('cachedVipInfo', JSON.stringify(this.cachedVipInfo));
        }
        if (this.$store.state.usedPre) {
          this.cachedUsedPre = this.$store.state.usedPre;
          localStorage.setItem('cachedUsedPre', JSON.stringify(this.cachedUsedPre));
        }
      } catch (error) {
        // console.warn('保存缓存数据失败:', error);
      }
    },
    
    // 清除缓存数据
    clearCachedData() {
      this.cachedUserInfo = {};
      this.cachedVipInfo = {};
      this.cachedUsedPre = 0;
      localStorage.removeItem('cachedUserInfo');
      localStorage.removeItem('cachedVipInfo');
      localStorage.removeItem('cachedUsedPre');
    },
    
    //获取收藏更新量
    getCollectNum(){
      getCollectInfo().then(res =>{
        if(res.status == 1){
          this.$store.commit("setAttr", {
              name: "collectNum",
              val: Number(res.data.total),
          });
          this.$store.commit("setAttr", {
              name: "gathersNum",
              val: Number(res.data.gather),
          });
          this.$store.commit("setAttr", {
              name: "shortNum",
              val: Number(res.data.shorturl),
          });
        }
      })
    },
    changeTheme(item) {
      this.$store.commit("setAttr", {
        name: "themeBtn",
        val: item,
      });
      if (item == "light" || item == "dark") {
        this.$utils.changeTheme(item);
      } else {
        this.listenTheme(1);
      }
    },
    listenTheme(index = 0) {
      const darkModeMediaQuery = window.matchMedia(
        "(prefers-color-scheme: dark)"
      );
      if (this.$store.state.themeBtn == "system" && index == 1) {
        if (darkModeMediaQuery.matches) {
          this.$utils.changeTheme("dark");
        } else {
          this.$utils.changeTheme("light");
        }
      }
      const darkModeChanged = (e) => {
        // 当深色模式状态发生变化时，执行相应的操作
        if (this.$store.state.themeBtn == "system") {
          if (darkModeMediaQuery.matches) {
            this.$utils.changeTheme("dark");
          } else {
            this.$utils.changeTheme("light");
          }
        }
      };
      darkModeMediaQuery.addListener(darkModeChanged);
    },
    itemClick(item) {
      if(this.$route.path=='/files' && item.path=='/files'){
        this.$store.commit("getfiles", {
          name: "query",
          value: {
            folder_id: 0,
            folders: [{folder_id: 0, folder_name: "全部文件"}]
          },
        });
      }
      if(item.pathName != '订阅号'){
        let routerName = this.$router.history.current.name || ''
        const routerNameList = ['s','fmDown','tNewdown']
        if(routerNameList.includes('s') && (this.$store.state.statusNum == '60001' || this.$store.state.statusNum == '60004')){
          if (localStorage.getItem("rebate_model") == 1) { 
            this.$store.commit("setAttr", {
              name: "route_ids",
              val: ['A1','B33'],
            })
          } else if (localStorage.getItem("rebate_model") == 3) {
            this.$store.commit("setAttr", {
              name: "route_ids",
              val: ['A1','B32'],
            })
          } else {
            this.$store.commit("setAttr", {
              name: "route_ids",
              val: ['A1','B3'],
            })
          }
        }
        if (routerNameList.includes(routerName)) {
          this.$utils.routeModeReported('C10',this.$store.state.voucher);
        }
        if(!routerNameList.includes(routerName) && item.pathName == '会员' && routerName != 'vip'){
          this.$store.commit("setAttr", {
            name: "route_ids",
            val: ['A1'],
          })
          this.$utils.routeModeReported('B7',this.$store.state.voucher);
        }
        this.$router.push(item.path);
      } else {
        window.open(this.$glb.Jmdyh + `/popularhome?platfro=${localStorage.getItem('platfro')}`, "_blank")
        // window.open(this.$glb.Jmdyh + `/sub`, "_blank")
      }
    },
    goFeedback(){
      window.open('https://jinshuju.net/f/eykqQ2')
    },
    bindPhone(data) {
      let params = { msgid: this.msgid, ...data }
      bindPhoneAPI(params).then(res => {
        if (res.status == '1') {
          this.isShowBindPhone = false
          this.$store.commit('getuserVuex')
          this.$toast(res.msg, 1)

          if (this.$store.state.bindPhoneCallback) {
            this.$store.state.bindPhoneCallback()
          }
          setTimeout(() =>{
            const url = process.env.VUE_APP_DAREN_URL + '/referralProgram'
            window.open(url, '_blank')
          },300)
        } else {
          this.$toast(res.msg, 2)
        }
      })
    },
    //判断手机号是否为空
    checkPhoneEmpty() {
      // 从 store 中获取 userInfo 对象
      const userInfo = this.$store.state.userInfo
      // 检查 phone 属性是否为空字符串
      if (userInfo && userInfo.phone == '') {
        return true
      }
      return false
    },
    getPhoneCode(phone, pcode, sms_type) {
      this.phone_item = {
        phone,
        pcode,
        sms_type,
      }
      this.getPhoneAly()
    },
    getPhoneAly(captcha_verify, validate = {}) {
      return new Promise(resolve => {
        if (validate == 'close') {
          return
        }
        bindPhoneSendCode({
          phone: this.phone_item.phone,
          pcode: this.phone_item.pcode,
          sms_type: this.phone_item.sms_type,
          captcha_verify: captcha_verify || '',
          lot_number: validate?.lot_number || '',
          captcha_output: validate?.captcha_output || '',
          pass_token: validate?.pass_token || '',
          gen_time: validate?.gen_time || '',
        }).then(res => {
          if (res.status == '1') {
            resolve({
              result: true,
              validate: true,
            })
            this.$toast(res.msg, 1)
            this.msgid = res.data.msgid
            this.bindType = 3
            this.timerA = setInterval(() => {
              this.minute()
              this.$refs.bindPhoneCom?.onFocus()
            }, 1000)
          } else if (res.status == 90001) {
            resolve({
              result: false,
              validate: false,
            })
            this.$toast(res.msg, 2)
            this.$AliCode.handleOpen(this.getPhoneAly)
          } else if (res.status == 90002) {
            this.$utils.initgt4(
              "5b0562a75492b420626b745b229e83a4",
              this.getPhoneAly
            );
          } else {
            resolve({
              result: true,
              validate: true,
            })
            this.$toast(res.msg, 2)
          }
        })
      })
    },
    minute() {
      this.time = this.time - 1
      if (this.time == 0) {
        this.time = 60
        clearInterval(this.timerA)
      }
    },
    realNameAuth(data) {
      realNameAuth(data).then(res => {
        if (res.status == '1') {
          this.isShowBindPhone = false
          this.$store.commit('getuserVuex')
          this.$toast(res.msg, 1)
        } else {
          this.$toast(res.msg, 2)
        }
      })
    },
    oepnExPand() {
      if (this.checkPhoneEmpty()) {
        this.bindType = 1
        this.isShowBindPhone = true
        return
      }
      const url = process.env.VUE_APP_DAREN_URL + '/referralProgram'
      window.open(url, '_blank')
    },
  },
  mounted() {
    this.listenTheme();
    this.$store.commit("setAttr", {
      name: "getCollectcallback",
      val: this.getCollectNum,
    });
    //获取收藏更新量
    if(this.$utils.getCookie(this.$glb.fmCookieName) !== null){
      this.getCollectNum()
    }
    
    // 监听Vuex数据变化，同步更新缓存
    this.$watch('$store.state.userInfo', (newVal) => {
      if (Object.keys(newVal).length > 0) {
        this.saveCachedData();
      }
    }, { deep: true });
    
    this.$watch('$store.state.VipInfo', (newVal) => {
      if (Object.keys(newVal).length > 0) {
        this.saveCachedData();
      }
    }, { deep: true });
    
    this.$watch('$store.state.usedPre', (newVal) => {
      if (newVal) {
        this.saveCachedData();
      }
    });
  },
  beforeDestroy() {
    // 在组件销毁前延迟清除缓存，给用户足够时间看到数据
    setTimeout(() => {
      this.clearCachedData();
    }, 2000); // 延迟2秒清除缓存
  },
  watch: {
    // 监听登录状态变化，在退出登录时延迟清除缓存
    '$store.state.userInfo': {
      handler(newVal, oldVal) {
        // 如果从有数据变为空对象，说明用户退出登录了
        if (Object.keys(oldVal).length > 0 && Object.keys(newVal).length === 0) {
          // 延迟清除缓存，让用户看到数据
          setTimeout(() => {
            this.clearCachedData();
          }, 3000); // 延迟3秒清除缓存
        }
      },
      deep: true
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
